import React from 'react';
import {
  Alert,
  Box,
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Text,
} from '@razorpay/blade/components';
import { WarningModalType } from 'components/SalaryStructures/types';

function SalaryStructureWarningModals({
  isOpen,
  onClose,
  type,
  primaryButtonText,
  onPrimaryButtonClick,
  secondaryButtonText,
  onSecondaryButtonClick,
  isSecondaryButton,
  isSecondaryButtonDisabled,
  isPrimaryButtonDisabled,
}: {
  isOpen: boolean;
  onClose: () => void;
  type: WarningModalType[keyof WarningModalType];
  primaryButtonText: string;
  onPrimaryButtonClick: () => void;
  secondaryButtonText?: string;
  onSecondaryButtonClick?: () => void;
  isSecondaryButton?: boolean;
  isSecondaryButtonDisabled?: boolean;
  isPrimaryButtonDisabled?: boolean;
}) {
  const getHeaderTitle = () => {
    switch (type) {
      case 'PROCEED_TO_EDIT':
        return 'Proceed to edit Structure';
      default:
        return '';
    }
  };

  const getModalContent = () => {
    switch (type) {
      case 'PROCEED_TO_EDIT':
        return (
          <Alert
            description={
              <Box display="flex" flexDirection="column" gap="spacing.7">
                <Text size="small" weight="regular">
                  {' '}
                  Once you edit it, the changes will affect employees to whom this structure is
                  applied.{' '}
                </Text>{' '}
                <Text size="small" weight="regular">
                  Please note that for payroll-finalized employees, the structure will remain
                  unchanged.
                </Text>
              </Box>
            }
            marginTop="spacing.4"
            color="information"
            isDismissible={false}
          />
        );
      default:
        return null;
    }
  };

  return (
    <Modal isOpen={isOpen} onDismiss={onClose}>
      <ModalHeader title={getHeaderTitle()} />
      <ModalBody>{getModalContent()}</ModalBody>

      <ModalFooter>
        <Box display="flex" gap="spacing.3" justifyContent="flex-end" width="100%">
          {isSecondaryButton && secondaryButtonText && onSecondaryButtonClick && (
            <Button
              variant="tertiary"
              onClick={onSecondaryButtonClick}
              isDisabled={isSecondaryButtonDisabled}>
              {secondaryButtonText}
            </Button>
          )}
          <Button onClick={onPrimaryButtonClick} isDisabled={isPrimaryButtonDisabled}>
            {primaryButtonText}
          </Button>
        </Box>
      </ModalFooter>
    </Modal>
  );
}

export { SalaryStructureWarningModals };
